var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.335,
    height: 65.286,
    viewBox: "0 0 65.335 65.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_066-spreadsheet_app",
    "data-name": "066-spreadsheet app",
    d: "M55.892,55.269a9.454,9.454,0,0,1-9.443-9.443v-22.2c.52-12.53,18.37-12.521,18.886,0v22.2A9.454,9.454,0,0,1,55.892,55.269Zm0-35.985a4.344,4.344,0,0,0-4.339,4.339v22.2a4.339,4.339,0,0,0,8.677,0v-22.2A4.344,4.344,0,0,0,55.892,19.284ZM9.443,55.269A9.454,9.454,0,0,1,0,45.826V38.935c.52-12.53,18.37-12.521,18.886,0v6.891A9.454,9.454,0,0,1,9.443,55.269Zm0-20.672A4.344,4.344,0,0,0,5.1,38.935v6.891a4.339,4.339,0,0,0,8.677,0V38.935A4.344,4.344,0,0,0,9.443,34.6ZM32.668,55.269a9.454,9.454,0,0,1-9.443-9.443V9.585c.52-12.53,18.37-12.521,18.886,0V45.826A9.454,9.454,0,0,1,32.668,55.269Zm0-50.022a4.344,4.344,0,0,0-4.339,4.339V45.826a4.339,4.339,0,0,0,8.677,0V9.585A4.344,4.344,0,0,0,32.668,5.247ZM65.335,62.925a2.552,2.552,0,0,0-2.552-2.552H2.552a2.552,2.552,0,0,0,0,5.1H62.783A2.552,2.552,0,0,0,65.335,62.925Z",
    transform: "translate(0 -0.191)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnalytics);
export default __webpack_public_path__ + "static/media/ic_analytics.5ba8398f.svg";
export { ForwardRef as ReactComponent };